import { useGetEiaFuelRateLinesQuery } from "@api/graphql/generated/generated-types";
import { useAuth } from "@src/common/hooks/useAuth";
import { EiaFuelRateDisplay } from "./EiaFuelRateNote";

/**
 * The EIA rate context for an order's dynamic fuel surcharge lines, keyed by
 * surchargePricingRuleId for joining to breakdown items. The rate is served by a
 * dedicated query rather than a field on the breakdown, so the order-price read
 * path stays untouched for screens that don't show it; renderers receive this map
 * as an optional prop and show nothing when it is absent or empty.
 */
export function useEiaFuelRateByRuleId(
  orderId: string | undefined,
): Record<string, EiaFuelRateDisplay> {
  const { courierId } = useAuth();

  const { data } = useGetEiaFuelRateLinesQuery({
    variables: { courierId: courierId || "", orderId: orderId || "" },
    skip: !courierId || !orderId,
  });

  return Object.fromEntries(
    (data?.eiaFuelRateLines ?? []).map((line) => [
      line.surchargePricingRuleId,
      line.eiaFuelRate,
    ]),
  );
}
